import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { Header } from 'semantic-ui-react';

type Props = {
  header: string;
  children: ReactNode;
};

export const ReadonlyField = ({ header, children, ...props }: Props) => {
  return (
    <div {...props}>
      <Header as="h5">{header}</Header>
      <Value>{children}</Value>
    </div>
  );
};

const Value = styled.div`
  font-size: 14px;
  margin-bottom: 1rem;
`;
